import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import { getUserInfo } from './utils/cache'
import * as API from './utils/apiService'

import Login from './views/Login.vue'
import Register from './views/Register.vue'
import ForgetPwd from './views/ForgetPwd.vue'
import Member from './views/Member.vue'
import Payment from './views/Payment.vue'
import Apply from './views/Apply.vue'
import Appeal from './views/Appeal.vue'
import Mytask from './views/Mytask.vue'
import Repwd from './views/Repwd.vue'
import EditPayment from './views/EditPayment.vue'
import EditAppeal from './views/EditAppeal.vue'
import EditApplication from './views/EditApplication.vue'

import NotMemberIndex from './views/NotMemberIndex.vue'
import NotMemberMiddleWare from './views/NotMemberMiddleWare.vue'
import NotMemberPayment from './views/NotMemberPayment.vue'
import ApplicationInfo from './views/ApplicationInfo.vue'
import PreviewApplication from './views/PreviewApplication.vue'
import Progress from './views/Progress.vue'
import NotMemberEditPayment from './views/NotMemberEditPayment.vue'

Vue.use(Router)

// 会员侧边菜单的路由
export const leftRoutes = [
  {
    path: '/member',
    component: Member,
    icon: require('./assets/member.png'),
    label: '会员信息',
    name: 'member',
    leftMenu: 'member'
  },
  {
    path: '/payment',
    component: Payment,
    icon: require('./assets/payment.png'),
    label: '缴费凭证',
    name: 'payment',
    leftMenu: 'payment'
  },
  {
    path: '/apply',
    component: Apply,
    icon: require('./assets/apply.png'),
    label: '会议报名',
    name: 'apply',
    leftMenu: 'apply'
  },
  {
    path: '/appeal',
    component: Appeal,
    icon: require('./assets/appeal.png'),
    label: '会员诉求',
    name: 'appeal',
    leftMenu: 'appeal'
  },
  {
    path: '/mytask',
    component: Mytask,
    icon: require('./assets/mytask.png'),
    label: '站内信',
    name: 'mytask',
    leftMenu: 'mytask'
  },
  {
    path: '/repwd',
    component: Repwd,
    icon: require('./assets/repwd.png'),
    label: '修改密码',
    name: 'repwd',
    leftMenu: 'repwd'
  }
]

// 非会员侧边路由
export const notMemberLeftRouters = [
  {
    path: '/notMemberMiddleWare',
    component: NotMemberMiddleWare,
    icon: require('./assets/apply.png'),
    label: '申请信息',
    name: 'notMemberMiddleWare',
    leftMenu: 'notMemberMiddleWare'
  },
  {
    path: '/notMemberPayment',
    component: NotMemberPayment,
    icon: require('./assets/apply.png'),
    label: '缴费凭证',
    name: 'notMemberPayment',
    leftMenu: 'notMemberPayment'
  }
]

// 没有顶部、侧边模板的路由
const hiddenRouters = [
  {
    path: '/login',
    component: Login,
    name: 'login'
  },
  {
    path: '/register',
    component: Register,
    name: 'register'
  },
  {
    path: '/forgetPwd',
    component: ForgetPwd,
    name: 'forgetPwd'
  }
]

// 会员没有侧边菜单的路由
const subRouters = [
  {
    path: '/',
    component: Member,
    icon: require('./assets/member.png'),
    label: '会员信息',
    name: 'member',
    leftMenu: 'member'
  },
  {
    path: '/editPayment',
    name: 'editPayment',
    component: EditPayment,
    leftMenu: 'payment'
  },
  {
    path: '/editAppeal',
    name: 'editAppeal',
    component: EditAppeal,
    leftMenu: 'appeal'
  },
  {
    path: '/editApplication',
    name: 'editApplication',
    component: EditApplication,
    leftMenu: 'member'
  }
]

// 非会员没有侧边菜单的路由
const notMemberSubRouters = [
  {
    path: '/previewApplication',
    component: PreviewApplication,
    icon: require('./assets/apply.png'),
    label: '申请信息',
    name: 'previewApplication',
    leftMenu: 'notMemberMiddleWare'
  },
  {
    path: '/notMemberEditApplication',
    component: EditApplication,
    icon: require('./assets/apply.png'),
    label: '申请信息',
    name: 'notMemberEditApplication',
    leftMenu: 'notMemberMiddleWare'
  },
  {
    path: '/notMemberIndex',
    component: NotMemberIndex,
    icon: require('./assets/apply.png'),
    label: '申请信息',
    name: 'NotMemberIndex',
    leftMenu: 'notMemberMiddleWare'
  },
  {
    path: '/applicationInfo',
    component: ApplicationInfo,
    icon: require('./assets/apply.png'),
    label: '申请信息',
    name: 'applicationInfo',
    leftMenu: 'notMemberMiddleWare'
  },
  {
    path: '/progress',
    component: Progress,
    icon: require('./assets/apply.png'),
    label: '申请信息',
    name: 'progress',
    leftMenu: 'notMemberMiddleWare'
  },
  {
    path: '/notMemberEditPayment',
    component: NotMemberEditPayment,
    icon: require('./assets/apply.png'),
    label: '缴费凭证',
    name: 'notMemberEditPayment',
    leftMenu: 'notMemberPayment'
  }
]

const allRouter = leftRoutes.concat(hiddenRouters).concat(subRouters).concat(notMemberLeftRouters).concat(notMemberSubRouters)

const router = window.router = new Router({
  routes: allRouter
})

// // 解决vueRoute('NavigationDuplicated')报错问题
// const originalPush = Router.prototype.push
// Router.prototype.push = function push (location) {
//   return originalPush.call(this, location).catch(err => err)
// }

router.beforeEach((to, from, next) => {
  // 如果要去的页面既不是登录，也不是注册，也不是忘记密码
  if (to.name !== 'login' && to.name !== 'register' && to.name !== 'forgetPwd') {
    // 从cache获取用户信息 getUserInfo
    const userInfo = getUserInfo()
    // 如果cache获取到了, 不用管, 没获取到时
    if (!userInfo) {
      // 没有获取到用户信息,跳转到登录
      router.push('/login')
      return
    }
  }

  const isHiddenContainer = hiddenRouters.some((item) => {
    return item.name === to.name
  })
  // 隐藏外面的主体
  if (isHiddenContainer) {
    store.commit('changeIsHiddenContainer', true)
  } else {
    store.commit('changeIsHiddenContainer', false)
    // 决定leftNav选中哪个

    let params = {
      userid: getUserInfo().id
    }
    API.findOneInfo(params).then(resp => {
      if (resp.resultCode === '0000') {
        // let isExist = true
        if (resp.data && resp.data.memberno) { // 会员
          store.commit('changeMemberInfo', resp.data)
          leftRoutes.concat(subRouters).some(item => {
            if (item.name === to.name) {
              store.commit('changeActive', item.leftMenu)
              return true
            }
          })
        } else { // 非会员
          store.commit('changeMemberInfo', {})
          notMemberLeftRouters.concat(notMemberSubRouters).some(item => {
            if (item.name === to.name) {
              store.commit('changeActive', item.leftMenu)
              return true
            }
          })

          // 去申请信息的具体页面时，判断当前非会员状态
          // if (['notMemberIndex', 'applicationInfo', 'progress'].indexOf(to.name) !== -1) {
          //   if (resp.data) {
          //     if (resp.data.status === '1') { // 有数据没编号且状态为已处理
          //       next('/notMemberIndex')
          //     } else if (resp.data.status === '3') { // 有数据没编号且状态为暂存
          //       next('/applicationInfo')
          //     } else {
          //       next('/progress') // 有数据没编号且状态为未处理
          //     }
          //   } else {
          //     next('/applicationInfo')
          //   }
          //   return
          // }
        }
        // if (!isExist) { // 当前访问的路由不存在非会员路由中
        //   next('/login')
        //   return
        // }
      }
    })
  }
  next()
})

export default router
